import React, { ForwardedRef, forwardRef, useImperativeHandle, useRef } from 'react';

import { ProductAdderRoot, UpsellBookingModal } from '@src/domains/products';
import PackageBookingModal from '@src/components/ProductPackage/PackageBookingModal';
import { MultiProductBookingModalRef } from '@src/domains/products/features/multiProductBooking/MultiProductBookingModal';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import { useAppSelector } from '@src/core/hooks';
import { multiProductBookingSelector } from '@src/stores/multiProductBooking';

type AdderRootContainerRef = () => void;

const AdderRootContainer = forwardRef((_, ref: ForwardedRef<AdderRootContainerRef>) => {
  const packageId = usePackageIdParam();
  const booking = useAppSelector(multiProductBookingSelector);
  const modalRef = useRef<MultiProductBookingModalRef>(null);

  useImperativeHandle(
    ref,
    () => () => {
      modalRef.current?.triggerClose();
    },
    [],
  );

  if (packageId) return <PackageBookingModal ref={modalRef} />;
  if (booking?.isOpen) return <UpsellBookingModal ref={modalRef} />;
  return <ProductAdderRoot />;
});

AdderRootContainer.displayName = 'AdderRootContainer';

export default AdderRootContainer;
